export default "__VITE_PUBLIC_ASSET__68efdab3__"